export const ROOT_URL = 'https://api.powerwaste.app'
export const API_V2_URL = 'https://v2.api.powerwaste.app'
